<template>
<div>
    <div><h3>BLM Data Export</h3></div>
    <div class="wrapper">
        <div class="row row-wider">
            <div class="col-md-12" style="min-height: 150px;">
                <loader v-if="isLoading"/>
                <div>
                    <h4>Download BLM Data Export Files</h4>
                    
                    <button class="btn btn-primary" v-on:click="download()">Download</button>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import mediaService from '@/services/mediaService'
import blmDataExportService from '@/services/blmDataExportService'
import loggingService from '@/services/util/loggingService'

import loader from '@/components/Loader'

export default {
    components: {
        loader
    },
    data: function () {
        return {
            isDebug: false,
            isLoading: false
        }
    },
    mounted () {
        this.log('mounted')
    },
    methods: {
        log (message) {
            loggingService.log(this.isDebug, 'BLM Data Export', message)
        },
        download () {
            blmDataExportService.get(this.$http).then(response => {
                mediaService.saveFileToDownload(response, 'blm_data_export.zip')
            })
        }
    }
}
</script>



// WEBPACK FOOTER //
// BlmDataExport.vue?12cb7e36